module.exports = __webpack_public_path__ + "img/P1.41941373.jpg";